var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-input", {
        attrs: {
          type: "price-number",
          "required-mark": _vm.field.required,
          "floating-label": _vm.field.name,
          clearable: true,
          required: _vm.error,
          "required-condition": _vm.error,
          "allow-negative": true,
          "fractional-length": Infinity,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }